import {styled} from "styled-components";
import {Button, Card, Tag} from "antd";

export const StyledCard = styled(Card)`

    .ant-card-body {
        padding: 10px 8px;
    }

`;
export const StyledTag = styled(Tag)`
    background-color: var(--thirdColor);
    font-size: .5rem !important;
    border-radius: 10px;
    padding: 0px 10px 0px 10px;

`;
export const StyledButton = styled(Button)`
  color: var(--thirdColor);
    font-size: .7rem !important;
    font-weight: bold;
    border-radius: 7px;
`;
